import React, { Component } from "react";
import styled from "styled-components";
import ContentEditable from "react-contenteditable";
import { marked } from "marked";
import TurndownService from "turndown";

const Container = styled.div`
    font-size: 14px;
    width: 100%;
    height: 100%;
    
    ul {
        margin: 10px 0px 10px 0px;
    }
    
    h1, h2, h3 {
        margin: 0;
        font-size: 16px;
    }
    
    .editable {
        outline: none;
    }
    
    p {
        margin-bottom: 10px;
        line-height: 1.4;
    }
    
    textarea {
        width: 100%;
        height: 100%;
        resize: none;
        outline: none;
        border: none;
        font-family: "Source Sans Pro";
        font-size: 14px;
        min-height: 150px;
    }
    
`;

export class AiSlideContentEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            html: this.normalizeText(props.text)
        };
    }

    normalizeText(text) {
        // strip outer quotes from text
        text = text?.replace(/^"+|"+$/g, "");

        let html = marked.parse(text ?? "", { breaks: true });
        // strip trailing <br>
        html = html.replace(/<br>$/g, "");

        return html;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.text !== this.props.text) {
            this.setState({ html: this.normalizeText(this.props.text) });
        }
    }

    getMarkdown() {
        let markdown = new TurndownService().turndown(this.state.html);
        return markdown;
    }

    handleChange = event => {
        let { onChange } = this.props;
        this.setState({ html: event.target.value });
        onChange(event.target.value);
    }

    render() {
        const { html } = this.state;

        return (
            <Container>
                {/*<textarea value={text} onChange={event => onChange(event.target.value)} placeholder="Enter slide content..." />*/}
                <ContentEditable className="editable" html={html} onChange={this.handleChange} placeholder="Enter a description of the slide..." />
            </Container>
        );
    }
}

